import { GispagheIntegrationPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'
import EmployeesData from 'modules/payroll_integrations/components/Content/EmployeeData'
import Table from 'modules/payroll_integrations/components/Table'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'
import type { Codeable, ColumnNames } from 'modules/payroll_integrations/lib/types'

const GispagheIntegration = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(GispagheIntegrationPageDocument, {
    variables: { companyId: company.id },
  })

  const INTEGRATION_NAME = PayrollIntegration.gispaghe
  const COLUMN_NAMES: ColumnNames = [
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.header.concept'
      ),
      colSpan: 4,
      attribute: 'concept',
    },
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.header.value'
      ),
      colSpan: 4,
      attribute: 'value',
    },
  ]

  const codeables: Record<string, Codeable> = {
    legalEntity: {
      position: 0,
      collection: data?.companies.legalEntitiesConnection.nodes ?? [],
      class: 'LegalEntity',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.concept.legal_entity'
      ),
    },
    workplace: {
      position: 1,
      collection: data?.locations.locationsConnection.nodes ?? [],
      class: 'Location',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.concept.workplace'
      ),
    },
    leave_type: {
      position: 2,
      collection: data?.timeoff.leaveTypesConnection.nodes ?? [],
      class: 'Timeoff::LeaveType',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.concept.leave_type'
      ),
    },
    splitCustomTimeRangeCategory: {
      position: 3,
      collection: data?.timeSettings.splitCustomTimeRangeCategoriesConnection.nodes ?? [],
      class: 'TimeSettings::SplitCustomTimeRangeCategory',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_gispaghe.settings.form.concept.custom_time_category'
      ),
    },
  }

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body variant="full" loading={loading} error={null}>
        <Table columnNames={COLUMN_NAMES} codeables={codeables} integration={INTEGRATION_NAME} />
        <EmployeesData
          integration_name={i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_gispaghe.integration_name'
          )}
        />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default GispagheIntegration
